export enum NdsInputCheckboxSize {
  S = 'small',
  M = 'medium',
}
